<script setup lang="ts">
import type { NuxtError } from "#app"

defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object as () => NuxtError,
})
</script>

<template>
  <div v-if="error" class="wrapper">
    <h1>Error {{ error.statusCode }}</h1>
    <div>Oh dear, something went wrong.</div>
    <div>
      <NuxtLink to="/">Return home</NuxtLink>
    </div>
    <div class="error">
      <code class="error-msg">{{ error }}</code>
      <code class="error-stack">{{ error.stack }}</code>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  padding: 2rem;
  max-width: 960px;
  margin: 0 auto;
}
h1 {
  margin-bottom: 1rem;
}
.error {
  text-align: left;
}
.error-msg {
  display: block;
  margin-bottom: 1rem;
}
.error-stack {
  display: block;
}
</style>
